import { type AxisScale, LineSeries as VisxLineSeries } from '@visx/xychart';

import type { BaseAreaSeriesProps } from '@visx/xychart/lib/components/series/private/BaseAreaSeries';

export type LineVariant = 'dashed' | 'solid';

export const getLineVariantProps = (variant?: LineVariant) => {
  const baseProps = { strokeWidth: 2 };
  return variant === 'dashed' ? { ...baseProps, strokeDasharray: '4 4' } : baseProps;
};

export const LineSeries = <XScale extends AxisScale, YScale extends AxisScale, Datum extends object>({
  color,
  data,
  dataKey,
  xAccessor,
  yAccessor,
  variant,
  'data-testid': dataTestId,
}: Pick<BaseAreaSeriesProps<XScale, YScale, Datum>, 'data' | 'dataKey' | 'xAccessor' | 'yAccessor'> & {
  color?: string;
  variant: LineVariant;
  'data-testid'?: string;
}) => {
  const variantProps = getLineVariantProps(variant);
  return (
    <VisxLineSeries
      data={data}
      dataKey={dataKey}
      xAccessor={xAccessor}
      yAccessor={yAccessor}
      stroke={color}
      data-testid={dataTestId}
      {...variantProps}
    />
  );
};
